import { useMemo } from 'react';

import {
  useMembershipPointExpirationScheduleQuery,
  MembershipPointExpirationScheduleQuery,
} from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';

import {
  PAGINATION_AFTER_PARAM,
  PAGINATION_BEFORE_PARAM,
  PAGINATION_PAGE_SIZE,
} from './point-expiration-schedule.constants';

type UsePointExpirationScheduleParams = {
  memberId: string;
};

export const usePointExpirationSchedule = (params: UsePointExpirationScheduleParams) => {
  const { memberId } = params;

  const [paginationInfo, onPageChange] = usePaginationParams({
    pageSize: PAGINATION_PAGE_SIZE,
    beforeParamName: PAGINATION_BEFORE_PARAM,
    afterParamName: PAGINATION_AFTER_PARAM,
  });

  const { data, loading, error, paginationProps } = usePaginatedQuery(
    useMembershipPointExpirationScheduleQuery,
    'memberships.edges[0].node.pointExpirationSchedule.pageInfo',
    PAGINATION_PAGE_SIZE,
    {
      variables: {
        membershipId: memberId,
      },
    },
    paginationInfo,
    onPageChange,
  );

  const pointExpirations = useMemo(() => {
    const typedData = data as MembershipPointExpirationScheduleQuery | undefined;
    const node = typedData?.memberships?.edges[0]?.node;
    if (!node) return [];

    return node.pointExpirationSchedule.edges?.map((e) => e.node) || [];
  }, [data]);

  return {
    loading,
    error,
    data: pointExpirations,
    paginationProps,
  };
};
